module.exports = __webpack_public_path__ + "static/media/SWSCRC6-15.acabf33b.mp3";